export default __webpack_public_path__ + "static/media/color_picker.c4acc351.png";